.filter {
	border-top-left-radius: 10px;
	border-bottom-left-radius: 10px;
	background-color: #ffffff;
	box-shadow: 5px 5px 10px #dfe1e6;
	border-right: 1px solid #d8d8d8;
	padding-right: 8px;
	padding-left: 8px;
	min-height: 82vh;
	max-height: 82vh;

	padding-left: 0px !important;
	padding-right: 0px !important;

	@media (max-width: 820px) {
		min-height: 77vh;
		max-height: 77vh;
	}

	@media (max-width: 400px) {
		min-height: 73vh;
		max-height: 73vh;
	}

	.filterTitle {
		margin-top: 8px;
		margin-bottom: 8px;
		height: 4%;

		.titleH4 {
			font-size: 15px;
			padding-right: 8px;
			padding-left: 8px;
		}

		.filterHr {
			margin-top: 8px;
			margin-bottom: 8px;
		}
	}

	.divContent {
		height: 87%;
		overflow-y: auto;
		overflow-x: hidden;

		&::-webkit-scrollbar {
			width: 5px;
		}

		&::-webkit-scrollbar-track {
			background: #f1f1f1;
		}

		&::-webkit-scrollbar-thumb {
			background-color: #a8a8a8;
			border-radius: 15px;
		}

		.divForm {
			margin-top: 10px;
			padding-right: 7px;
			padding-left: 7px;

			.divLabel {
				margin-bottom: 4px;
				display: flex;
				align-items: center;

				.label {
					font-weight: 500;
					font-size: 14px;
				}
			}
		}
	}

	.divFooter {
		display: flex;
		justify-content: space-evenly;
		height: 5%;

		.buttonClean {
			padding: 2px 15px;
			font-size: 13px;
			font-weight: 500;

			background-color: white !important;
			color: #81ba43 !important;

			&:hover {
				background-color: #5d9125 !important;
				color: white !important;
			}
		}

		.buttonApply {
			padding: 2px 15px;
			font-size: 13px;
			font-weight: 500;
		}
	}
}

.filterButton {
	display: inline-flex;
	background-color: #fafafa;
	padding: 7px 10px;
	border-radius: 10px;
	font-size: 15px;
	font-weight: 500;
	margin-right: 10px;
	cursor: pointer;

	background-image: url("../../assets/images/desktop/filtro.svg");
	background-position: left;
	background-repeat: no-repeat;
	background-size: 40px 15px;

	&.empty_products {
		background-image: url("../../assets/images/desktop/eliminar1.svg");
	}

	span {
		margin-left: 27px;
	}

	&:hover {
		background-image: url("../../assets/images/desktop/filtro-white.svg");
		background-color: #7fb02f;
		color: white;

		&.empty_products {
			fill: white !important;
			stroke: white !important;
			background-image: url("../../assets/images/desktop/eliminar1.svg");
		}
	}

	&.active {
		background-image: url("../../assets/images/desktop/filtro-white.svg");
		background-color: #7fb02f;
		color: white;
	}
}

.filterButtonMain {
	display: inline-flex;
	background-color: #f1f1f1;
	padding: 5px 11px;
	border-radius: 5px;
	font-size: 14px;
	font-weight: 500;
	margin-right: 10px;
	cursor: pointer;

	background-image: url("../../assets/images/desktop/filtro.svg");
	background-position: left;
	background-repeat: no-repeat;
	background-size: 40px 10px;

	span {
		margin-left: 27px;
	}

	&:hover {
		background-image: url("../../assets/images/desktop/filtro-white.svg");
		background-color: #7fb02f;
		color: white;
	}

	&.active {
		background-image: url("../../assets/images/desktop/filtro-white.svg");
		background-color: #7fb02f;
		color: white;
	}
}

.filter_col_main {
	display: none;
}

.button_back {
	padding-right: 5px;
	width: 3em;
	display: none;

	@media (max-width: 750px) {
		display: block;
	}
}

@media (max-width: 750px) {
	.filter {
		margin-bottom: 10px;
	}

	.filter_col_main {
		display: block;
		margin-top: 5px;
		padding-left: 20px !important;
		padding-right: 20px !important;
		display: flex;
		align-items: center;
	}

	.filter_col {
		display: none;
	}
}
